export default {

    'project.app.Footer.text': 'PA Project - Area of Telematics Engineering - University of A Coruña',
    'project.app.Header.home': 'Home',
    'project.app.Header.logout': 'Logout',
    'project.app.Home.welcome': 'MiniPortal main page content!',

    'project.global.buttons.addStep': 'Add Step',
    'project.global.buttons.previousStep': 'Previous Step',
    'project.global.buttons.nextStep': 'Next Step',
    'project.global.buttons.Play1': 'Play',
    'project.global.buttons.Stop': 'Stop',

    'project.global.buttons.undo': 'Undo',
    'project.global.buttons.clear': 'Clear',
    'project.global.buttons.download': 'Download',

    'project.global.buttons.team_selection': 'Team Selection',
    'project.global.buttons.season_selection': 'Season Selection',
    'project.global.buttons.player_selection': 'Player Selection',
    'project.global.buttons.exercises_selection': 'Exercise Selection',
    'project.global.buttons.stretching_selection': 'Stretching Selection',
    'project.global.buttons.lesion_selection': 'Lesion Selection',
    'project.global.buttons.play_selection': 'Plays Selection',

    'project.calendar.buttons.editEvent': 'Edit Event',
    'project.calendar.buttons.addEvent': 'Add Event',
    'project.calendar.buttons.deleteEvent': 'Delete Event',





















    'project.common.ErrorDialog.title': 'Error',

    'project.global.buttons.signin': 'Sign In',

    'project.global.buttons.charts': 'Charts',
    'project.global.buttons.calendar': 'Calendar',
    'project.global.buttons.users': 'Users',
    'project.users.fields.remove' : 'Remove',


    'project.global.list.users': 'Users List',
    'project.global.create.users': 'Create User',
    'project.global.buttons.board': 'Board',
    'project.global.buttons.animation': 'Animation',
    'project.global.buttons.general': 'General',
    'project.global.buttons.statistics': 'Statistics',
    'project.global.buttons.home': 'Home',



    'project.global.buttons.filter': 'Filter',

    'project.global.buttons.find': 'Search',
    'project.global.buttons.cancel': 'Cancel',
    'project.global.buttons.close': 'Close',
    'project.global.buttons.next': 'Next',
    'project.global.buttons.ok': 'OK',
    'project.global.buttons.back': 'Back',
    'project.global.buttons.save': 'Save',
    'project.global.exceptions.NetworkError': 'Network error',
    'project.global.fields.date': 'Date',
    'project.global.fields.email': 'Email address',
    'project.global.fields.firstName': 'First name',
    'project.global.fields.lastName': 'Last name',
    'project.global.fields.name': 'Name',
    'project.global.fields.role': 'Role',
    'project.global.fields.password': 'Password',

    'project.global.fields.currentPassword': 'Current Password',
    'project.global.fields.newPassword': 'New Password',
    'project.global.fields.confirmPassword': 'Confirm Password',

    'project.global.fields.postalAddress': 'Postal address',
    'project.global.fields.postalCode': 'Postal code',
    'project.global.fields.userName': 'Username',
    'project.global.fields.userName1': 'UserName',
    'project.global.validator.email': 'Provide a correct e-mail address',
    'project.global.validator.passwordsDoNotMatch': 'Passwords do not match',
    'project.global.validator.required': 'Required field',

    'project.users.ChangePassword.fields.confirmNewPassword': 'Confirm new password',
    'project.users.ChangePassword.fields.newPassword': 'New password',
    'project.users.ChangePassword.fields.oldPassword': 'Old password',
    'project.users.ChangePassword.title': 'Change password',
    'project.users.Login.title': 'Login',
    'project.users.SignUp.fields.confirmPassword': 'Confirm password',
    'project.users.SignUp.title': 'Sign up',
    'project.users.UpdateProfile.title': 'Update profile',

    'project.users.profile.title': 'Profile',


    'project.teams.FindTeamByName.noTeam': 'No teams found',
    'project.seasons.FindSeason.noSeason': 'No seasons found',


    'project.teams.fields.teams' : 'Teams',
    'project.seasons.fields.seasons' : 'Seasons',
    'project.lesion.fields.lesion' : 'Lesion',
    'project.trainings.fields.trainings' : 'Trainings',
    'project.games.fields.games' : 'Games',
    'project.stretchings.fields.stretchings' : 'Stretchings',
    'project.exercises.fields.exercises' : 'Exercises',


    'project.players.fields.players' : 'Players',
    'project.statistics.fields.addGameStatistics' : 'Add Game Statistics',
    'project.statistics.fields.game' : 'Game Statistics',

    'project.teams.fields.team' : 'Team',
    'project.seasons.fields.season' : 'Season',
    'project.games.fields.game' : 'Game',
    'project.players.fields.player' : 'Player',



    //exercises
    'project.exercises.fields.addExercise' : 'Add Exercise',
    'project.exercises.fields.updateExercise' : 'Update Exercise',
    'project.exercises.fields.name' : 'Name',
    'project.exercises.fields.description' : 'Description',
    'project.exercises.fields.objective' : 'Objective',
    'project.exercises.fields.type' : 'Type',
    'project.exercises.fields.typeOnly' : 'Type',
    'project.exercises.fields.tactic' : 'Tactic',
    'project.exercises.fields.technique' : 'Technique',
    'project.exercises.fields.physical' : 'Physical',
    'project.exercises.fields.globalized' : 'Global',
    'project.exercises.fields.specific' : 'Specific',
    'project.exercises.fields.psychological' : 'Psychological',
    'project.exercises.fields.strategy' : 'Strategy',
    'project.exercises.fields.preMatch' : 'PreMatch',

    'project.exercises.fields.myExercises' : 'My Exercises',



    //games
    'project.games.fields.addGame' : 'Add Game',
    'project.games.fields.updateGame' : 'Update Game',
    'project.games.fields.date' : 'Date',
    'project.games.fields.rival' : 'Rival',
    'project.games.fields.myGames' : 'My Games',
    'project.games.fields.removeGame' : 'Remove Game',

    //lesion
    'project.lesion.fields.addLesion' : 'Add Lesion',
    'project.lesion.fields.updateLesion' : 'Update Lesion',
    'project.lesion.fields.lesionName' : 'Name',
    'project.lesion.fields.medication' : 'Medication',
    'project.lesion.fields.lesionType' : 'Type',
    'project.lesion.fields.muscle' : 'Muscle',
    'project.lesion.fields.tendon' : 'Tendon',
    'project.lesion.fields.joint' : 'Joint',
    'project.lesion.fields.spine' : 'Spine',
    'project.lesion.fields.psychological' : 'Psychological',
    'project.lesion.fields.withLesion' : 'With Lesion',
    'project.lesion.fields.myLesion' : 'My Lesion',
    'project.lesion.fields.injured' : 'Injured',


    //notes
    'project.notes.fields.note' : 'Note',
    'project.notes.fields.addNote' : 'Add Note',
    'project.notes.fields.updateNote' : 'Update Note',
    'project.notes.fields.title' : 'Title',
    'project.notes.fields.myNotes' : 'My Notes',
    'project.notes.fields.notes' : 'Notes',

    //players
    'project.players.fields.addPlayer' : 'Add Player',
    'project.players.fields.updatePlayer' : 'Update Player',
    'project.players.fields.name' : 'Name',
    'project.players.fields.playerName' : 'Player Name',
    'project.players.fields.primaryLastName' : 'Primary Last Name',
    'project.players.fields.secondLastName' : 'Second Last Name',
    'project.players.fields.position' : 'Position',
    'project.players.fields.pointGuard' : 'PointGuard',
    'project.players.fields.shootingGuard' : 'ShootingGuard',
    'project.players.fields.smallForward' : 'SmallForward',
    'project.players.fields.powerForward' : 'PowerForward',
    'project.players.fields.center' : 'Center',
    'project.players.fields.trends' : 'Trends',
    'project.players.fields.phoneNumber' : 'Phone Number',
    'project.players.fields.email' : 'Email',
    'project.players.fields.dni' : 'Dni',
    'project.players.fields.findPlayerByDni' : 'Find Player By Dni',
    'project.players.fields.findPlayerByNameAndSurnames' : 'Find Player By Name and Surnames',
    'project.players.fields.nameAndSurnames' : 'Name and Surnames',
    'project.players.fields.clear' : 'Clear',


    //plays
    'project.plays.fields.addPlay' : 'Add Play',
    'project.plays.fields.updatePlay' : 'Update Play',
    'project.plays.fields.play' : 'Play',
    'project.plays.fields.attack' : 'Attack',
    'project.plays.fields.defense' : 'Defense',
    'project.plays.fields.gesture' : 'Gesture',
    'project.plays.fields.pointGuardText' : 'PointGuard Text',
    'project.plays.fields.shootingGuardText' : 'ShootingGuard Text',
    'project.plays.fields.smallForwardText' : 'SmallForward Text',
    'project.plays.fields.powerForwardText' : 'PowerForward Text',
    'project.plays.fields.centerText' : 'Center Text',

    //seasons
    'project.seasons.fields.addSeason' : 'Add Season',
    'project.plays.fields.updateSeason' : 'Update Season',
    'project.seasons.fields.startDate' : 'Start Date',
    'project.seasons.fields.endDate' : 'End Date',
    'project.seasons.fields.name' : 'Name',
    'project.seasons.fields.allSeasons' : 'All Seasons',
    'project.seasons.fields.seasonsBetweenTwoDates' : 'Seasons Between Two Dates',





    //statistics
    'project.statistics.fields.playerGameStatistics' : 'Player Game Statistics',
    'project.statistics.fields.statistics' : 'Statistics',

    'project.statistics.fields.totalPoints' : 'Total Points',
    'project.statistics.fields.totalPointsTeam1' : 'Team Points',
    'project.statistics.fields.totalPointsRival1' : 'Rival Points',

    'project.statistics.fields.totalThreePointShots' : 'Three Point Shots',
    'project.statistics.fields.totalSetShots' : 'Set Shots',
    'project.statistics.fields.totalFreeShots' : 'Free Shots',

    'project.statistics.fields.totalFailThreePointShots' : 'Total Fail Three Point Shots',
    'project.statistics.fields.totalfailSetShots' : 'Total fail Set Shots',
    'project.statistics.fields.totalfailFreeShots' : 'Total fail Free Shots',

    'project.statistics.fields.totalRebounds' : 'Rebounds',
    'project.statistics.fields.totalBlockedShot' : 'Blocked Shot',
    'project.statistics.fields.totalAssists' : 'Assists',

    'project.statistics.fields.totalPersonalFouls' : 'Personal Fouls',
    'project.statistics.fields.totalTechnicalFouls' : 'Technical Fouls',
    'project.statistics.fields.totalUnsportsmanlikeFouls' : 'Unsportsmanlike Fouls',

    'project.statistics.fields.team_rival' : '(My Team - Rival)',

    'project.statistics.fields.myteam' : 'My Team',
    'project.statistics.fields.myrival' : 'Rival',

    'project.statistics.fields.failShots' : 'Failed',

    'project.statistics.fields.shotsFailed' : 'Fail shots',
    'project.statistics.fields.shots' : 'Scored Shots',


    'project.statistics.fields.addPlayerGameStatistics' : 'Add Player Game Statistics',

    'project.statistics.fields.duration' : 'Duration',
    'project.statistics.fields.minutes' : 'Minutes',

    'project.statistics.fields.totalPointsRival' : 'Total Points Rival',
    'project.statistics.fields.totalThreePointShotsRival' : 'Total Three Point Shots Rival',
    'project.statistics.fields.totalSetShotsRival' : 'Total Set Shots Rival',
    'project.statistics.fields.totalFreeShotsRival' : 'Total Free Shots Rival',

    'project.statistics.fields.totalReboundsRival' : 'Total Rebounds Rival',
    'project.statistics.fields.totalBlockedShotRival' : 'Total Blocked Shot Rival',
    'project.statistics.fields.totalAssistsRival' : 'Total Assists Rival',

    'project.statistics.fields.totalPersonalFoulsRival' : 'Total Personal Fouls Rival',
    'project.statistics.fields.totalTechnicalFoulsRival' : 'Total Technical Fouls Rival',
    'project.statistics.fields.totalUnsportsmanlikeFoulsRival' : 'Total Unsportsmanlike Fouls Rival',



    'project.statistics.fields.threePointShots' : 'Three Point Shots',
    'project.statistics.fields.setShots' : 'Set Shots',
    'project.statistics.fields.freeShots' : 'Free Shots',

    'project.statistics.fields.failThreePointShots' : 'Fail Three Point Shots',
    'project.statistics.fields.failSetShots' : 'Fail Set Shots',
    'project.statistics.fields.failFreeShots' : 'Fail Free Shots',

    'project.statistics.fields.rebounds' : 'Rebounds',
    'project.statistics.fields.blockedShot' : 'Blocked Shot',
    'project.statistics.fields.assists' : 'Assists',

    'project.statistics.fields.personalFouls' : 'Personal Fouls',
    'project.statistics.fields.technicalFouls' : 'Technical Fouls',
    'project.statistics.fields.unsportsmanlikeFouls' : 'Unsportsmanlike Fouls',

    'project.statistics.fields.update' : 'Update',
    'project.statistics.fields.updateGameStatistics' : 'Update Game Statistics',
    'project.statistics.fields.updatePlayerGameStatistics' : 'Update Player Game Statistics',

    //stretchings
    'project.stretchings.fields.addStretching' : 'Add Stretching',
    'project.stretchings.fields.myStretchings' : 'My Stretchings',

    'project.stretchings.fields.stretchingName' : 'Name',
    'project.stretchings.fields.stretchingType' : 'Type',
    'project.stretchings.fields.hamstrings' : 'Hamstrings',
    'project.stretchings.fields.buttocks' : 'Buttocks',
    'project.stretchings.fields.calf' : 'Calf',
    'project.stretchings.fields.adductors' : 'Adductors',
    'project.stretchings.fields.shoulder' : 'Shoulder',
    'project.stretchings.fields.quadriceps' : 'Quadriceps',
    'project.stretchings.fields.back' : 'Back',
    'project.stretchings.fields.pectoral' : 'Pectoral',
    'project.stretchings.fields.crotch' : 'Crotch',
    'project.stretchings.fields.triceps' : 'Triceps',
    'project.stretchings.fields.updateStretching' : 'Update Stretching',

    //teams
    'project.teams.fields.changeTeam' : 'Change Team',

    'project.teams.fields.name' : 'Name',
    'project.teams.fields.arena' : 'Arena',
    'project.teams.fields.owner' : 'Owner',

    'project.teams.fields.addTeamToSeason' : 'Add Team to Season',



    'project.teams.fields.addTeam' : 'Add Team',
    'project.teams.fields.updateTeam' : 'Update Team',
    'project.teams.fields.teamName' : 'Team Name',

    'project.plays.fields.plays' : 'Plays',


    'project.teams.fields.allTeams' : 'All Teams',




    //trainings
    'project.trainings.fields.addTraining' : 'Add Training',
    'project.trainings.fields.updateTraining' : 'Update Training',
    'project.trainings.fields.myTrainings' : 'My Trainings',
    'project.trainings.fields.removeTraining' : 'Remove Trainings',

    'project.trainings.fields.objective' : 'Objective',

    'project.trainings.fields.training' : 'Training',
    'project.trainings.fields.durationOnly' : 'Duration',

    //sidebar
    'project.sidebar.fields.club' : 'Club',
    'project.sidebar.fields.events' : 'Events',
    'project.sidebar.fields.physicalHealth' : 'Physical Health',
}
